import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { EmbeddedSurface } from "@/surfaces/embedded/embedded-surface";
import { StandaloneSurface } from "@/surfaces/standalone/standalone-surface";
import type { Surface } from "@/surfaces/surface";
import { dismissBootSplash } from "./boot-splash";
import { AppProviders } from "./providers/app-providers";
import { appRouter } from "./router";

/** 应用组合根：只选择呈现面；路由、Provider 和各 surface 外壳分别在自己的模块中装配。 */
export default function App({ surface }: { surface: Surface }) {
  useEffect(() => {
    dismissBootSplash();
  }, []);

  const routedApplication = <RouterProvider router={appRouter} />;

  return (
    <AppProviders>
      {surface === "embedded" ? <EmbeddedSurface>{routedApplication}</EmbeddedSurface> : <StandaloneSurface>{routedApplication}</StandaloneSurface>}
    </AppProviders>
  );
}
